import { Icon } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { useHistory } from 'react-router-dom';
import { ICON_SIZE } from '../../../global/constants';
interface Props {
  backNavigationPath?: string;
}
export default function ResponsiveNavbar({ backNavigationPath }: Props) {
  const history = useHistory();

  return (
    <>
      <Icon role='button' onClick={() => (backNavigationPath ? history.push(backNavigationPath) : history.goBack())}>
        <SVGIcon
          name='responsive-back-icon'
          width={ICON_SIZE.XXL}
          height={ICON_SIZE.XXL}
          viewBox={`0 0 ${ICON_SIZE.XXL} ${ICON_SIZE.XXL}`}
          fill='var(--text-secondary)'
        />
      </Icon>
    </>
  );
}
